// Catálogo i18n de la Clasificación regional (PRD §4.9) — es-ES.
// Traducido de la fuente pt-BR (anexos del decreto MG + Portaria IGAM).
export const regionalClassificationCatalogEsES = {
  "norms": {
    "mgIndustry": "MG Decreto n.º 48.140/2021 - Presas para disposición de residuos o relaves de la industria",
    "mgMining": "MG Decreto n.º 48.140/2021 - Presas para disposición de residuos o relaves de la minería",
    "mgWater": "MG Decreto n.º 48.140/2021 - Presas para acumulación de agua asociados a procesos industriales o de minería",
    "igam": "IGAM"
  },
  "mgIndustry": {
    "sections": {
      "cri": { "label": "CRI", "subtitle": "1 - Clasificación de riesgo" },
      "pda": { "label": "PDA", "subtitle": "2 - Potencial de daño ambiental" }
    },
    "grades": {
      "ct": "1.1 - Características técnicas - CT",
      "ec": "1.2 - Estado de conservación - EC",
      "psb": "1.3 - Plan de seguridad de la presa - PSB",
      "pda": "2 - Clasificación según el potencial de daño ambiental - PDA"
    },
    "columns": {
      "ctA": "Altura",
      "ctB": "Longitud",
      "ctC": "Caudal de proyecto",
      "ctD": "Método constructivo",
      "ctE": "Auscultación",
      "ecF": "Fiabilidad de las estructuras de vertido",
      "ecG": "Filtración",
      "ecH": "Deformaciones y asentamientos",
      "ecI": "Deterioro de los taludes / paramentos",
      "psbJ": "Documentación de proyecto",
      "psbK": "Estructura organizativa y cualificación de los profesionales del equipo de Seguridad de la Presa",
      "psbL": "Manuales de procedimientos para inspecciones de seguridad y monitoreo",
      "psbM": "Plan de Acción de Emergencia – PAE (cuando lo exige el órgano fiscalizador)",
      "psbN": "Informes de inspección y monitoreo de la instrumentación y de Análisis de Seguridad",
      "pdaA": "Volumen total del embalse",
      "pdaB": "Existencia de población aguas abajo",
      "pdaC": "Impacto ambiental",
      "pdaD": "Impacto socioeconómico"
    },
    "options": {
      "ctA": {
        "score0": "Altura ≤ 10m",
        "score1": "10m < Altura < 30m",
        "score4": "30m ≤ Altura ≤ 60m",
        "score7": "Altura > 60m"
      },
      "ctB": {
        "score0": "Longitud ≤ 50m",
        "score1": "50m < Longitud < 200m",
        "score2": "200 ≤ Longitud ≤ 600m",
        "score3": "Longitud > 600m"
      },
      "ctC": {
        "score0": "CMP (Crecida Máxima Probable) o Decamilenaria",
        "score2": "Milenaria",
        "score5": "TR = 500 años",
        "score10": "TR inferior a 500 años o desconocida / estudio no confiable"
      },
      "ctD": {
        "score1": "Etapa única",
        "score3": "Estructura recrecida"
      },
      "ctE": {
        "score0": "Existe instrumentación de acuerdo con el proyecto técnico o no se aplica el uso de método de auscultación",
        "score2": "Existe instrumentación en desacuerdo con el proyecto, pero en proceso de instalación de instrumentos para adecuación al proyecto",
        "score6": "Existe instrumentación en desacuerdo con el proyecto sin proceso de instalación de instrumentos para adecuación al proyecto",
        "score8": "Presa no instrumentada en desacuerdo con el proyecto"
      },
      "ecF": {
        "score0": "Estructuras civiles bien mantenidas y en operación normal / presa sin necesidad de estructuras de vertido",
        "score3": "Estructuras con problemas identificados y medidas correctivas en implantación",
        "score6": "Estructuras con problemas identificados y sin implantación de las medidas correctivas necesarias",
        "score10": "Estructuras con problemas identificados, con reducción de capacidad de vertido y sin medidas correctivas"
      },
      "ecG": {
        "score0": "Filtración totalmente controlada por el sistema de drenaje",
        "score3": "Humedad o surgencia en las áreas aguas abajo, paramentos, taludes y estribos estables y monitoreados",
        "score6": "Humedad o surgencia en las áreas aguas abajo, paramentos, taludes o estribos sin implantación de las medidas correctivas necesarias",
        "score10": "Surgencia en las áreas aguas abajo con arrastre de material o con caudal creciente o infiltración del material contenido, con potencial de comprometer la seguridad de la estructura"
      },
      "ecH": {
        "score0": "No existen deformaciones ni asentamientos con potencial de comprometer la seguridad de la estructura",
        "score2": "Existencia de grietas y hundimientos con medidas correctivas en implantación",
        "score6": "Existencia de grietas y hundimientos sin implantación de las medidas correctivas necesarias",
        "score10": "Existencia de grietas, hundimientos o deslizamientos, con potencial de comprometer la seguridad de la estructura"
      },
      "ecI": {
        "score0": "No existe deterioro de taludes ni paramentos",
        "score2": "Fallas en la protección de los taludes y paramentos, presencia de vegetación arbustiva",
        "score6": "Erosiones superficiales, armadura expuesta, presencia de vegetación arbórea, sin implantación de las medidas correctivas necesarias",
        "score10": "Depresiones acentuadas en los taludes, deslizamientos, surcos profundos de erosión, con potencial de comprometer la seguridad de la estructura"
      },
      "psbJ": {
        "score0": "Proyecto ejecutivo y \"como construido\"",
        "score2": "Proyecto ejecutivo o \"como construido\"",
        "score3": "Proyecto \"como está\"",
        "score5": "Proyecto básico",
        "score8": "Proyecto conceptual",
        "score10": "No hay documentación de proyecto"
      },
      "psbK": {
        "score0": "Posee unidad administrativa con profesional técnico cualificado responsable de la seguridad de la presa",
        "score1": "Posee profesional técnico cualificado (propio o contratado) responsable de la seguridad de la presa",
        "score3": "Posee unidad administrativa sin profesional técnico cualificado responsable de la seguridad de la presa",
        "score6": "No posee unidad administrativa ni responsable técnico cualificado de la seguridad de la presa"
      },
      "psbL": {
        "score0": "Posee manuales de procedimientos para inspección, monitoreo y operación",
        "score2": "Posee solo manual de procedimientos de monitoreo",
        "score4": "Posee solo manual de procedimientos de inspección",
        "score8": "No posee manuales ni procedimientos formales para monitoreo e inspecciones"
      },
      "psbM": {
        "score0": "Posee PAE",
        "score2": "No posee PAE (no lo exige el órgano fiscalizador)",
        "score4": "PAE en elaboración",
        "score8": "No posee PAE (cuando lo exige el órgano fiscalizador)"
      },
      "psbN": {
        "score0": "Emite regularmente informes de inspección y monitoreo basados en la instrumentación y de Auditoría de Seguridad",
        "score2": "Emite regularmente solo informes de Auditoría de Seguridad",
        "score4": "Emite regularmente solo informes de inspección y monitoreo",
        "score6": "Emite regularmente solo informes de inspección visual",
        "score8": "No emite regularmente informes de inspección y monitoreo ni de Auditoría de Seguridad"
      },
      "pdaA": {
        "score1": "Muy pequeño: ≤ 1 millón m³",
        "score2": "Pequeño: 1 millón a 5 millones m³",
        "score3": "Medio: 5 millones a 25 millones m³",
        "score4": "Grande: 25 millones a 50 millones m³",
        "score5": "Muy grande: ≥ 50 millones m³"
      },
      "pdaB": {
        "score0": "Inexistente — no existen personas permanentes/residentes ni temporales/en tránsito en el área afectada aguas abajo de la presa",
        "score3": "Poco frecuente — no existen personas ocupando permanentemente el área afectada aguas abajo de la presa, pero existe carretera vecinal de uso local",
        "score5": "Frecuente — no existen personas ocupando permanentemente el área afectada aguas abajo de la presa, pero existe carretera municipal, estatal o federal u otro lugar y/o emprendimiento de permanencia eventual de personas que podrían ser afectadas",
        "score10": "Existente — existen personas ocupando permanentemente el área afectada aguas abajo de la presa, por lo tanto vidas humanas podrían ser afectadas"
      },
      "pdaC": {
        "score0": "Insignificante — área afectada aguas abajo de la presa se encuentra totalmente descaracterizada de sus condiciones naturales y la estructura almacena solo residuos Clase II, según la NBR 10.004 de la ABNT",
        "score2": "Poco significativo — área afectada aguas abajo de la presa no presenta área de interés ambiental relevante o áreas protegidas por legislación específica, excluidas las APP, y almacena solo residuos Clase II, según la NBR 10.004 de la ABNT",
        "score4": "Significativo — área afectada aguas abajo de la presa presenta área de interés ambiental relevante o áreas protegidas por legislación específica, excluidas las APP, y almacena solo residuos Clase II, según la NBR 10.004 de la ABNT",
        "score10": "Muy significativo — la presa almacena relaves o residuos sólidos clasificados como Clase I – Peligrosos, según la NBR 10.004 de la ABNT"
      },
      "pdaD": {
        "score0": "Inexistente — no existen instalaciones en el área afectada aguas abajo de la presa",
        "score1": "Bajo — existe pequeña concentración de instalaciones residenciales, agrícolas, industriales o de infraestructura de relevancia socioeconómico-cultural en el área afectada aguas abajo de la presa",
        "score3": "Medio — existe concentración moderada de instalaciones residenciales, agrícolas, industriales o de infraestructura de relevancia socioeconómico-cultural en el área afectada aguas abajo de la presa",
        "score5": "Alto — existe alta concentración de instalaciones residenciales, agrícolas, industriales o de infraestructura de relevancia socioeconómico-cultural en el área afectada aguas abajo de la presa"
      }
    }
  },
  "mgMining": {
    "sections": {
      "cri": { "label": "CRI", "subtitle": "1 - Clasificación de riesgo" },
      "pda": { "label": "PDA", "subtitle": "2 - Potencial de daño ambiental" }
    },
    "grades": {
      "ct": "1.1 - Características técnicas - CT",
      "ec": "1.2 - Estado de conservación - EC",
      "psb": "1.3 - Plan de seguridad de la presa - PSB",
      "pda": "2 - Clasificación según el potencial de daño ambiental - PDA"
    },
    "columns": {
      "ctA": "Altura",
      "ctB": "Longitud",
      "ctC": "Caudal de proyecto",
      "ctD": "Método constructivo",
      "ctE": "Auscultación",
      "ecF": "Fiabilidad de las estructuras de vertido",
      "ecG": "Filtración",
      "ecH": "Deformaciones y asentamientos",
      "ecI": "Deterioro de los taludes / paramentos",
      "psbJ": "Documentación de proyecto",
      "psbK": "Estructura organizativa y cualificación de los profesionales del equipo de Seguridad de la Presa",
      "psbL": "Manuales de procedimientos para inspecciones de seguridad y monitoreo",
      "psbM": "Plan de Acción de Emergencia – PAE (cuando lo exige el órgano fiscalizador)",
      "psbN": "Informes de inspección y monitoreo de la instrumentación y de Análisis de Seguridad",
      "pdaA": "Volumen total del embalse",
      "pdaB": "Existencia de población aguas abajo",
      "pdaC": "Impacto ambiental",
      "pdaD": "Impacto socioeconómico"
    },
    "options": {
      "ctA": {
        "score0": "Altura ≤ 10m",
        "score1": "10m < Altura < 30m",
        "score4": "30m ≤ Altura ≤ 60m",
        "score7": "Altura > 60m"
      },
      "ctB": {
        "score0": "Longitud ≤ 50m",
        "score1": "50m < Longitud < 200m",
        "score2": "200 ≤ Longitud ≤ 600m",
        "score3": "Longitud > 600m"
      },
      "ctC": {
        "score0": "CMP (Crecida Máxima Probable) o Decamilenaria",
        "score2": "Milenaria",
        "score5": "TR = 500 años",
        "score10": "TR inferior a 500 años o desconocida / estudio no confiable"
      },
      "ctD": {
        "score0": "Etapa única",
        "score2": "Recrecimiento aguas abajo",
        "score5": "Recrecimiento por línea de centro",
        "score10": "Recrecimiento aguas arriba o desconocido, o que ya haya sido recrecida aguas arriba a lo largo del ciclo de vida de la estructura"
      },
      "ctE": {
        "score0": "Existe instrumentación de acuerdo con el proyecto técnico",
        "score2": "Existe instrumentación en desacuerdo con el proyecto, pero en proceso de instalación de instrumentos para adecuación al proyecto",
        "score6": "Existe instrumentación en desacuerdo con el proyecto sin proceso de instalación de instrumentos para adecuación al proyecto",
        "score8": "Presa no instrumentada en desacuerdo con el proyecto"
      },
      "ecF": {
        "score0": "Estructuras civiles bien mantenidas y en operación normal / presa sin necesidad de estructuras de vertido",
        "score3": "Estructuras con problemas identificados y medidas correctivas en implantación",
        "score6": "Estructuras con problemas identificados y sin implantación de las medidas correctivas necesarias",
        "score10": "Estructuras con problemas identificados, con reducción de capacidad de vertido y sin medidas correctivas"
      },
      "ecG": {
        "score0": "Filtración totalmente controlada por el sistema de drenaje",
        "score3": "Humedad o surgencia en las áreas aguas abajo, paramentos, taludes y estribos estables y monitoreados",
        "score6": "Humedad o surgencia en las áreas aguas abajo, paramentos, taludes o estribos sin implantación de las medidas correctivas necesarias",
        "score10": "Surgencia en las áreas aguas abajo con arrastre de material o con caudal creciente o infiltración del material contenido, con potencial de comprometer la seguridad de la estructura"
      },
      "ecH": {
        "score0": "No existen deformaciones ni asentamientos con potencial de comprometer la seguridad de la estructura",
        "score2": "Existencia de grietas y hundimientos con medidas correctivas en implantación",
        "score6": "Existencia de grietas y hundimientos sin implantación de las medidas correctivas necesarias",
        "score10": "Existencia de grietas, hundimientos o deslizamientos, con potencial de comprometer la seguridad de la estructura"
      },
      "ecI": {
        "score0": "No existe deterioro de taludes ni paramentos",
        "score2": "Fallas en la protección de los taludes y paramentos, presencia de vegetación arbustiva",
        "score6": "Erosiones superficiales, armadura expuesta, presencia de vegetación arbórea, sin implantación de las medidas correctivas necesarias",
        "score10": "Depresiones acentuadas en los taludes, deslizamientos, surcos profundos de erosión, con potencial de comprometer la seguridad de la estructura"
      },
      "psbJ": {
        "score0": "Proyecto ejecutivo y \"como construido\"",
        "score2": "Proyecto ejecutivo o \"como construido\"",
        "score3": "Proyecto \"como está\"",
        "score5": "Proyecto básico",
        "score8": "Proyecto conceptual",
        "score10": "No hay documentación de proyecto"
      },
      "psbK": {
        "score0": "Posee unidad administrativa con profesional técnico cualificado responsable de la seguridad de la presa",
        "score1": "Posee profesional técnico cualificado (propio o contratado) responsable de la seguridad de la presa",
        "score3": "Posee unidad administrativa sin profesional técnico cualificado responsable de la seguridad de la presa",
        "score6": "No posee unidad administrativa ni responsable técnico cualificado de la seguridad de la presa"
      },
      "psbL": {
        "score0": "Posee manuales de procedimientos para inspección, monitoreo y operación",
        "score2": "Posee solo manual de procedimientos de monitoreo",
        "score4": "Posee solo manual de procedimientos de inspección",
        "score8": "No posee manuales ni procedimientos formales para monitoreo e inspecciones"
      },
      "psbM": {
        "score0": "Posee PAE",
        "score2": "No posee PAE (no lo exige el órgano fiscalizador)",
        "score4": "PAE en elaboración",
        "score8": "No posee PAE (cuando lo exige el órgano fiscalizador)"
      },
      "psbN": {
        "score0": "Emite regularmente informes de inspección y monitoreo basados en la instrumentación y de Análisis de Seguridad",
        "score2": "Emite regularmente solo informes de Análisis de Seguridad",
        "score4": "Emite regularmente solo informes de inspección y monitoreo",
        "score6": "Emite regularmente solo informes de inspección visual",
        "score8": "No emite regularmente informes de inspección y monitoreo ni de Análisis de Seguridad"
      },
      "pdaA": {
        "score1": "Muy pequeño: ≤ 1 millón m³",
        "score2": "Pequeño: 1 millón a 5 millones m³",
        "score3": "Medio: 5 millones a 25 millones m³",
        "score4": "Grande: 25 millones a 50 millones m³",
        "score5": "Muy grande: ≥ 50 millones m³"
      },
      "pdaB": {
        "score0": "Inexistente — no existen personas permanentes/residentes ni temporales/en tránsito en el área afectada aguas abajo de la presa",
        "score3": "Poco frecuente — no existen personas ocupando permanentemente el área afectada aguas abajo de la presa, pero existe carretera vecinal de uso local",
        "score5": "Frecuente — no existen personas ocupando permanentemente el área afectada aguas abajo de la presa, pero existe carretera municipal, estatal o federal u otro lugar y/o emprendimiento de permanencia eventual de personas que podrían ser afectadas",
        "score10": "Existente — existen personas ocupando permanentemente el área afectada aguas abajo de la presa, por lo tanto vidas humanas podrían ser afectadas"
      },
      "pdaC": {
        "score0": "Insignificante — área afectada aguas abajo de la presa se encuentra totalmente descaracterizada de sus condiciones naturales y la estructura almacena solo residuos Clase II B – Inertes, según la NBR 10.004 de la ABNT",
        "score2": "Poco significativo — área afectada aguas abajo de la presa no presenta área de interés ambiental relevante o áreas protegidas por legislación específica, excluidas las APP, y almacena solo residuos Clase II B – Inertes, según la NBR 10.004 de la ABNT",
        "score6": "Significativo — área afectada aguas abajo de la presa presenta área de interés ambiental relevante o áreas protegidas por legislación específica, excluidas las APP, y almacena solo residuos Clase II B – Inertes, según la NBR 10.004 de la ABNT",
        "score8": "Muy significativo — la presa almacena relaves o residuos sólidos clasificados como Clase II A – No Inertes, según la NBR 10.004 de la ABNT",
        "score10": "Muy significativo agravado — la presa almacena relaves o residuos sólidos clasificados como Clase I – Peligrosos, según la NBR 10.004 de la ABNT"
      },
      "pdaD": {
        "score0": "Inexistente — no existen instalaciones en el área afectada aguas abajo de la presa",
        "score1": "Bajo — existe pequeña concentración de instalaciones residenciales, agrícolas, industriales o de infraestructura de relevancia socioeconómico-cultural en el área afectada aguas abajo de la presa",
        "score3": "Medio — existe concentración moderada de instalaciones residenciales, agrícolas, industriales o de infraestructura de relevancia socioeconómico-cultural en el área afectada aguas abajo de la presa",
        "score5": "Alto — existe alta concentración de instalaciones residenciales, agrícolas, industriales o de infraestructura de relevancia socioeconómico-cultural en el área afectada aguas abajo de la presa"
      }
    }
  },
  "mgWater": {
    "sections": {
      "cri": { "label": "CRI", "subtitle": "1 - Clasificación de riesgo" },
      "pda": { "label": "PDA", "subtitle": "2 - Potencial de daño ambiental" }
    },
    "grades": {
      "ct": "1.1 - Características técnicas - CT",
      "ec": "1.2 - Estado de conservación - EC",
      "psb": "1.3 - Plan de seguridad de la presa - PSB",
      "pda": "2 - Clasificación según el potencial de daño ambiental - PDA"
    },
    "columns": {
      "ctA": "Altura",
      "ctB": "Longitud",
      "ctC": "Tipo de presa según el material de construcción",
      "ctD": "Tipo de fundación",
      "ctE": "Edad de la presa",
      "ctF": "Caudal de proyecto",
      "ecG": "Fiabilidad de las estructuras de vertido",
      "ecH": "Fiabilidad de las estructuras de aducción",
      "ecI": "Filtración",
      "ecJ": "Deformaciones y asentamientos",
      "ecK": "Deterioro de los taludes / paramentos",
      "psbL": "Existencia de documentación de proyecto",
      "psbM": "Estructura organizativa y cualificación técnica de los profesionales del equipo de Seguridad de la Presa",
      "psbN": "Procedimientos de rutinas de inspecciones de seguridad y de monitoreo",
      "psbO": "Regla operacional de los dispositivos de descarga de la presa",
      "psbP": "Informes de inspección de seguridad con análisis e interpretación",
      "pdaA": "Volumen total del embalse",
      "pdaB": "Potencial de pérdida de vidas humanas",
      "pdaC": "Impacto ambiental",
      "pdaD": "Impacto socioeconómico"
    },
    "options": {
      "ctA": {
        "score0": "Altura ≤ 10m",
        "score1": "10m < Altura < 30m",
        "score2": "30m ≤ Altura ≤ 60m",
        "score3": "Altura > 60m"
      },
      "ctB": {
        "score2": "Longitud ≤ 200m",
        "score3": "Longitud > 200m"
      },
      "ctC": {
        "score1": "Hormigón convencional",
        "score2": "Mampostería de piedra / hormigón ciclópeo / hormigón compactado con rodillo – HCR",
        "score3": "Tierra homogénea / escollera / tierra-escollera"
      },
      "ctD": {
        "score1": "Roca sana",
        "score2": "Roca alterada dura con tratamiento",
        "score3": "Roca alterada sin tratamiento / roca alterada fracturada con tratamiento",
        "score4": "Roca alterada blanda / saprolito / suelo compacto",
        "score5": "Suelo residual / aluvión"
      },
      "ctE": {
        "score1": "Entre 30 y 50 años",
        "score2": "Entre 10 y 30 años",
        "score3": "Entre 5 y 10 años",
        "score4": "< 5 años o > 50 años o sin información"
      },
      "ctF": {
        "score3": "CMP (Crecida Máxima Probable) o Decamilenaria",
        "score5": "Milenaria",
        "score8": "TR = 500 años",
        "score10": "TR < 500 años o desconocida / estudio no confiable"
      },
      "ecG": {
        "score0": "Estructuras civiles e hidroelectromecánicas en pleno funcionamiento / canales de aproximación o de restitución o vertedero (tipo de cresta libre) desobstruidos",
        "score4": "Estructuras civiles e hidroelectromecánicas preparadas para la operación, pero sin fuentes de suministro de energía de emergencia / canales o vertedero (tipo de cresta libre) con erosiones u obstrucciones, pero sin riesgos para la estructura de vertido",
        "score7": "Estructuras civiles comprometidas o dispositivos hidroelectromecánicos con problemas identificados, con reducción de capacidad de caudal y con medidas correctivas en implantación / canales o vertedero (tipo de cresta libre) con erosiones y/o parcialmente obstruidos, con riesgo de comprometer la estructura de vertido",
        "score10": "Estructuras civiles comprometidas o dispositivos hidroelectromecánicos con problemas identificados, con reducción de capacidad de caudal y sin medidas correctivas / canales o vertedero (tipo de cresta libre) obstruidos o con estructuras dañadas"
      },
      "ecH": {
        "score0": "Estructuras civiles y dispositivos hidroelectromecánicos en condiciones adecuadas de mantenimiento y funcionamiento",
        "score4": "Estructuras civiles comprometidas o dispositivos hidroelectromecánicos con problemas identificados, con reducción de capacidad de caudal y con medidas correctivas en implantación",
        "score6": "Estructuras civiles comprometidas o dispositivos hidroelectromecánicos con problemas identificados, con reducción de capacidad de caudal y sin medidas correctivas"
      },
      "ecI": {
        "score0": "Filtración totalmente controlada por el sistema de drenaje",
        "score3": "Humedad o surgencia en las áreas aguas abajo, paramentos, taludes o estribos estabilizados y/o monitoreados",
        "score5": "Humedad o surgencia en las áreas aguas abajo, paramentos, taludes o estribos sin tratamiento o en fase de diagnóstico",
        "score8": "Surgencia en las áreas aguas abajo, taludes o estribos con arrastre de material o con caudal creciente"
      },
      "ecJ": {
        "score0": "Inexistente",
        "score1": "Existencia de grietas y hundimientos de pequeña extensión e impacto nulo",
        "score5": "Existencia de grietas y hundimientos de impacto considerable que generan necesidad de estudios adicionales o monitoreo",
        "score8": "Existencia de grietas, hundimientos o deslizamientos expresivos, con potencial de comprometer la seguridad"
      },
      "ecK": {
        "score0": "Inexistente",
        "score1": "Fallas en la protección de los taludes y paramentos, presencia de arbustos de pequeña extensión e impacto nulo",
        "score5": "Erosiones superficiales, armadura expuesta, crecimiento de vegetación generalizada, que genera necesidad de monitoreo o actuación correctiva",
        "score7": "Depresiones acentuadas en los taludes, deslizamientos, surcos profundos de erosión, con potencial de comprometer la seguridad"
      },
      "psbL": {
        "score0": "Proyecto ejecutivo y \"como construido\"",
        "score2": "Proyecto ejecutivo o \"como construido\"",
        "score4": "Proyecto básico",
        "score6": "Anteproyecto o proyecto conceptual",
        "score8": "No existe documentación de proyecto"
      },
      "psbM": {
        "score0": "Posee estructura organizativa con técnico responsable de la seguridad de la presa",
        "score4": "Posee técnico responsable de la seguridad de la presa",
        "score8": "No posee estructura organizativa ni responsable técnico de la seguridad de la presa"
      },
      "psbN": {
        "score0": "Posee y aplica procedimientos de inspección y monitoreo",
        "score3": "Posee y aplica solo procedimientos de inspección",
        "score5": "Posee y no aplica procedimientos de inspección y monitoreo",
        "score6": "No posee ni aplica procedimientos para monitoreo e inspecciones"
      },
      "psbO": {
        "score0": "Sí o vertedero tipo de cresta libre",
        "score6": "No"
      },
      "psbP": {
        "score0": "Emite regularmente los informes",
        "score3": "Emite los informes sin periodicidad",
        "score5": "No emite los informes"
      },
      "pdaA": {
        "score0": "Muy pequeño: ≤ 1 millón de m³",
        "score1": "Pequeño: 1 millón a 5 millones m³",
        "score2": "Medio: 5 millones a 25 millones m³",
        "score3": "Grande: 25 millones a 50 millones m³",
        "score4": "Muy grande: ≥ 50 millones m³"
      },
      "pdaB": {
        "score0": "Inexistente — no existen personas permanentes/residentes ni temporales/en tránsito en el área afectada aguas abajo de la presa",
        "score4": "Poco frecuente — no existen personas ocupando permanentemente el área afectada aguas abajo de la presa, pero existe carretera vecinal de uso local",
        "score8": "Frecuente — no existen personas ocupando permanentemente el área afectada aguas abajo de la presa, pero existe carretera municipal, estatal o federal u otro lugar y/o emprendimiento de permanencia eventual de personas que podrían ser afectadas",
        "score12": "Existente — existen personas ocupando permanentemente el área afectada aguas abajo de la presa, por lo tanto vidas humanas podrían ser afectadas"
      },
      "pdaC": {
        "score1": "Poco significativo — área afectada de la presa no representa área de interés ambiental, áreas protegidas por legislación específica o se encuentra totalmente descaracterizada de sus condiciones naturales",
        "score2": "Significativo — el área afectada incluye áreas de protección de uso sostenible (APA, FLONA, RESEX, etc.) o es área de interés ambiental y se encuentra poco descaracterizada de sus condiciones naturales",
        "score5": "Muy significativo — el área afectada incluye áreas de protección integral (ESEC, PARNA, REBIO, etc.), incluidas Tierras Indígenas, o es de gran interés ambiental en su estado natural"
      },
      "pdaD": {
        "score0": "Inexistente — no existen instalaciones ni servicios de navegación en el área afectada por accidente de la presa",
        "score1": "Bajo — existen de 1 a 5 instalaciones residenciales y comerciales, agrícolas, industriales o infraestructura en el área afectada de la presa",
        "score3": "Medio — existen más de 5 hasta 30 instalaciones residenciales y comerciales, agrícolas, industriales o de infraestructura en el área afectada de la presa",
        "score8": "Alto — gran concentración de instalaciones residenciales y comerciales, agrícolas, industriales, de infraestructura y servicios de ocio y turismo en el área afectada de la presa, o instalaciones portuarias o servicios de navegación"
      }
    }
  },
  "igam": {
    "sections": {
      "cri": { "label": "CRI", "subtitle": "1 - Clasificación de riesgo" },
      "dpa": { "label": "DPA", "subtitle": "2 - Daño potencial asociado" }
    },
    "grades": {
      "ct": "1.1 - Características técnicas - CT",
      "ec": "1.2 - Estado de conservación - EC",
      "psb": "1.3 - Plan de seguridad de la presa - PS",
      "dpa": "2 - Clasificación según el daño potencial asociado - DPA"
    },
    "columns": {
      "ctA": "Altura",
      "ctB": "Longitud",
      "ctC": "Tipo de presa según el material de construcción",
      "ctD": "Tipo de fundación",
      "ctE": "Edad de la presa",
      "ctF": "Caudal de proyecto",
      "ecG": "Fiabilidad de las estructuras de vertido",
      "ecH": "Fiabilidad de las estructuras de aducción",
      "ecI": "Filtración",
      "ecJ": "Deformaciones y asentamientos",
      "ecK": "Deterioro de los taludes / paramentos",
      "ecL": "Esclusa",
      "psbM": "Existencia de documentación de proyecto",
      "psbN": "Estructura organizativa y cualificación técnica de los profesionales del equipo de Seguridad de la Presa",
      "psbO": "Procedimientos de rutinas de inspecciones de seguridad y de monitoreo",
      "psbP": "Regla operacional de los dispositivos de descarga de la presa",
      "psbQ": "Informes de inspección de seguridad con análisis e interpretación",
      "dpaA": "Volumen total del embalse",
      "dpaB": "Potencial de pérdida de vidas humanas",
      "dpaC": "Impacto ambiental",
      "dpaD": "Impacto socioeconómico"
    },
    "options": {
      "ctA": {
        "score0": "Altura ≤ 15m",
        "score1": "15m < Altura < 30m",
        "score2": "30m ≤ Altura ≤ 60m",
        "score3": "Altura > 60m"
      },
      "ctB": {
        "score2": "Longitud ≤ 200m",
        "score3": "Longitud > 200m"
      },
      "ctC": {
        "score1": "Hormigón convencional",
        "score2": "Mampostería de piedra / hormigón ciclópeo / hormigón compactado con rodillo – HCR",
        "score3": "Tierra homogénea / escollera / tierra-escollera"
      },
      "ctD": {
        "score1": "Roca sana",
        "score2": "Roca alterada dura con tratamiento",
        "score3": "Roca alterada sin tratamiento / roca alterada fracturada con tratamiento",
        "score4": "Roca alterada blanda / saprolito / suelo compacto",
        "score5": "Suelo residual / aluvión"
      },
      "ctE": {
        "score1": "Entre 30 y 50 años",
        "score2": "Entre 10 y 30 años",
        "score3": "Entre 5 y 10 años",
        "score4": "< 5 años o > 50 años o sin información"
      },
      "ctF": {
        "score3": "CMP (Crecida Máxima Probable) o Decamilenaria",
        "score5": "Milenaria",
        "score8": "TR = 500 años",
        "score10": "TR < 500 años o desconocida / estudio no confiable"
      },
      "ecG": {
        "score0": "Estructuras civiles e hidroelectromecánicas en pleno funcionamiento / canales de aproximación o de restitución o vertedero (tipo de cresta libre) desobstruidos",
        "score4": "Estructuras civiles e hidroelectromecánicas preparadas para la operación, pero sin fuentes de suministro de energía de emergencia / canales o vertedero (tipo de cresta libre) con erosiones u obstrucciones, pero sin riesgos para la estructura de vertido",
        "score7": "Estructuras civiles comprometidas o dispositivos hidroelectromecánicos con problemas identificados, con reducción de capacidad de caudal y con medidas correctivas en implantación / canales o vertedero (tipo de cresta libre) con erosiones y/o parcialmente obstruidos, con riesgo de comprometer la estructura de vertido",
        "score10": "Estructuras civiles comprometidas o dispositivos hidroelectromecánicos con problemas identificados, con reducción de capacidad de caudal y sin medidas correctivas / canales o vertedero (tipo de cresta libre) obstruidos o con estructuras dañadas"
      },
      "ecH": {
        "score0": "Estructuras civiles y dispositivos hidroelectromecánicos en condiciones adecuadas de mantenimiento y funcionamiento",
        "score4": "Estructuras civiles comprometidas o dispositivos hidroelectromecánicos con problemas identificados, con reducción de capacidad de caudal y con medidas correctivas en implantación",
        "score6": "Estructuras civiles comprometidas o dispositivos hidroelectromecánicos con problemas identificados, con reducción de capacidad de caudal y sin medidas correctivas"
      },
      "ecI": {
        "score0": "Filtración totalmente controlada por el sistema de drenaje",
        "score3": "Humedad o surgencia en las áreas aguas abajo, paramentos, taludes o estribos estabilizados y/o monitoreados",
        "score5": "Humedad o surgencia en las áreas aguas abajo, paramentos, taludes o estribos sin tratamiento o en fase de diagnóstico",
        "score8": "Surgencia en las áreas aguas abajo, taludes o estribos con arrastre de material o con caudal creciente"
      },
      "ecJ": {
        "score0": "Inexistente",
        "score1": "Existencia de grietas y hundimientos de pequeña extensión e impacto nulo",
        "score5": "Existencia de grietas y hundimientos de impacto considerable que generan necesidad de estudios adicionales o monitoreo",
        "score8": "Existencia de grietas, hundimientos o deslizamientos expresivos, con potencial de comprometer la seguridad"
      },
      "ecK": {
        "score0": "Inexistente",
        "score1": "Fallas en la protección de los taludes y paramentos, presencia de arbustos de pequeña extensión e impacto nulo",
        "score5": "Erosiones superficiales, armadura expuesta, crecimiento de vegetación generalizada, que genera necesidad de monitoreo o actuación correctiva",
        "score7": "Depresiones acentuadas en los taludes, deslizamientos, surcos profundos de erosión, con potencial de comprometer la seguridad"
      },
      "ecL": {
        "score0": "No posee esclusa",
        "score1": "Estructuras civiles e hidroelectromecánicas bien mantenidas y funcionando",
        "score2": "Estructuras civiles comprometidas o dispositivos hidroelectromecánicos con problemas identificados y con medidas correctivas en implantación",
        "score4": "Estructuras civiles comprometidas o dispositivos hidroelectromecánicos con problemas identificados y sin medidas correctivas"
      },
      "psbM": {
        "score0": "Proyecto ejecutivo y \"como construido\"",
        "score2": "Proyecto ejecutivo o \"como construido\"",
        "score4": "Proyecto básico",
        "score6": "Anteproyecto o proyecto conceptual",
        "score8": "No existe documentación de proyecto"
      },
      "psbN": {
        "score0": "Posee estructura organizativa con técnico responsable de la seguridad de la presa",
        "score4": "Posee técnico responsable de la seguridad de la presa",
        "score8": "No posee estructura organizativa ni responsable técnico de la seguridad de la presa"
      },
      "psbO": {
        "score0": "Posee y aplica procedimientos de inspección y monitoreo",
        "score3": "Posee y aplica solo procedimientos de inspección",
        "score5": "Posee y no aplica procedimientos de inspección y monitoreo",
        "score6": "No posee ni aplica procedimientos para monitoreo e inspecciones"
      },
      "psbP": {
        "score0": "Sí o vertedero tipo de cresta libre",
        "score6": "No"
      },
      "psbQ": {
        "score0": "Emite regularmente los informes",
        "score3": "Emite los informes sin periodicidad",
        "score5": "No emite los informes"
      },
      "dpaA": {
        "score1": "Pequeño: ≤ 5 millones m³",
        "score2": "Medio: 5 millones a 75 millones m³",
        "score3": "Grande: 75 millones a 200 millones m³",
        "score5": "Muy grande: > 200 millones m³"
      },
      "dpaB": {
        "score0": "Inexistente — no existen personas permanentes/residentes ni temporales/en tránsito en el área afectada aguas abajo de la presa",
        "score4": "Poco frecuente — no existen personas ocupando permanentemente el área afectada aguas abajo de la presa, pero existe carretera vecinal de uso local",
        "score8": "Frecuente — no existen personas ocupando permanentemente el área afectada aguas abajo de la presa, pero existe carretera municipal, estatal o federal u otro lugar y/o emprendimiento de permanencia eventual de personas que podrían ser afectadas",
        "score12": "Existente — existen personas ocupando permanentemente el área afectada aguas abajo de la presa, por lo tanto vidas humanas podrían ser afectadas"
      },
      "dpaC": {
        "score1": "Poco significativo — el área afectada de la presa no representa área de interés ambiental, áreas protegidas por legislación específica o se encuentra totalmente descaracterizada de sus condiciones naturales",
        "score2": "Significativo — el área afectada incluye áreas de protección de uso sostenible (APA, FLONA, RESEX, etc.) o es área de interés ambiental y se encuentra poco descaracterizada de sus condiciones naturales",
        "score5": "Muy significativo — el área afectada incluye áreas de protección integral (ESEC, PARNA, REBIO, etc.), incluidas Tierras Indígenas, o es de gran interés ambiental en su estado natural"
      },
      "dpaD": {
        "score0": "Inexistente — no existen instalaciones ni servicios de navegación en el área afectada por accidente de la presa",
        "score1": "Bajo — existen instalaciones residenciales y comerciales, agrícolas, industriales o infraestructura en el área afectada de la presa",
        "score3": "Medio — existen instalaciones residenciales, agrícolas, industriales o infraestructura en el área afectada de la presa",
        "score8": "Alto — existe gran concentración de instalaciones residenciales, agrícolas, infraestructura y servicios de ocio y turismo en el área afectada de la presa, o instalaciones portuarias o servicios de navegación"
      }
    }
  }
} as const;
